












import Vue from 'vue';

export default Vue.extend({
  name: 'HForm',
  data() {
    return {
      valid: true,
    };
  },
  methods: {
    validate() {
      (this.$refs.form as Vue & { validate: () => boolean }).validate();
    },
    resetValidation() {
      (this.$refs.form as Vue & { resetValidation: () => boolean }).resetValidation();
    },
    isValid() {
      return this.valid;
    },
  },
});
